<template>
  <nav
      id="topMenu"
      class="left-0 bg-gray-50 border-gray-200 dark:bg-gray-900 w-full h-16 flex items-center px-10"
  >
    <!-- Logo -->
    <div class="absolute left-4">
      <router-link
          v-if="store.selectedProject"
          :to="`/${store.toUrl(store.selectedProject.spaceName)}/${store.toUrl(store.selectedProject.name)}/admin/`"
          class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <svg
            aria-hidden="true"
            class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
          <path
              d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"
          ></path>
        </svg>
        <span class="ml-3">Haxo Orders</span>
      </router-link>
    </div>

    <!-- Project selector, starting after side menu -->
    <div class="ml-64 flex items-center">
      <website-select/>
    </div>

    <!-- User menu on the right -->
    <div class="ml-auto flex items-center space-x-4">


      <!-- Dark mode toggle -->
      <span
          @click="toggleDarkMode"
          class="inline-flex justify-center items-center w-6 h-6 transition-colors cursor-pointer"
      ><svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          class="inline-block dark:text-white"
      >
                    <path
                        fill="currentColor"
                        d="M7.5,2C5.71,3.15 4.5,5.18 4.5,7.5C4.5,9.82 5.71,11.85 7.53,13C4.46,13 2,10.54 2,7.5A5.5,5.5 0 0,1 7.5,2M19.07,3.5L20.5,4.93L4.93,20.5L3.5,19.07L19.07,3.5M12.89,5.93L11.41,5L9.97,6L10.39,4.3L9,3.24L10.75,3.12L11.33,1.47L12,3.1L13.73,3.13L12.38,4.26L12.89,5.93M9.59,9.54L8.43,8.81L7.31,9.59L7.65,8.27L6.56,7.44L7.92,7.35L8.37,6.06L8.88,7.33L10.24,7.36L9.19,8.23L9.59,9.54M19,13.5A5.5,5.5 0 0,1 13.5,19C12.28,19 11.15,18.6 10.24,17.93L17.93,10.24C18.6,11.15 19,12.28 19,13.5M14.6,20.08L17.37,18.93L17.13,22.28L14.6,20.08M18.93,17.38L20.08,14.61L22.28,17.15L18.93,17.38M20.08,12.42L18.94,9.64L22.28,9.88L20.08,12.42M9.63,18.93L12.4,20.08L9.87,22.27L9.63,18.93Z"
                    ></path></svg
      ></span>
      <div v-if="auth0" class="relative inline-block text-left">
        <button
            type="button"
            id="dropdownDefaultButton"
            data-dropdown-toggle="dropdown"
            class="text-sm font-medium text-gray-700 dark:text-white inline-flex items-center focus:outline-none"
        >
          <img
              v-if="store.user.picture"
              class="h-8 w-8 rounded-full"
              :src="store.user.picture"
              alt=""
          />
          <span class="ml-2">{{ store.user.email }}</span>
          <svg
              class="w-2.5 h-2.5 ml-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
          >
            <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 4 4 4-4"
            />
          </svg>
        </button>

        <div
            id="dropdown"
            class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
        >
          <ul
              class="py-2 text-sm text-gray-700 dark:text-gray-200"
              aria-labelledby="dropdownDefaultButton"
          >
            <li>
              <a
                  href="#"
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              >Profil</a
              >
            </li>
            <li>
              <a
                  href="#"
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  @click="store.logout()"
              >Odhlásit se</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>
<script setup>
import WebsiteSelect from "@/components/websiteSelect.vue";
</script>
<script>
import {useAuth0} from "@auth0/auth0-vue";
import {useAppStore} from "@/stores/appStore"

export default {
  name: "top-menu.vue",
  data() {
    const auth0 = useAuth0();
    const store = useAppStore();
    return {
      auth0: auth0,
      store: store,
    };
  },
  methods: {
    logout() {
      this.store.$reset();
      this.auth0.logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    },
    toggleDarkMode() {
      if (document.documentElement.classList.contains("dark")) {
        document.documentElement.classList.remove("dark");
        localStorage.theme = "light";
      } else {
        document.documentElement.classList.add("dark");
        localStorage.theme = "dark";
      }
    },
  },
  mounted() {
    if (
        localStorage.theme === "dark" ||
        (!("theme" in localStorage) &&
            window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  },
};
</script>

<style scoped></style>
